import React from "react";
import { AiFillPhone } from "react-icons/ai";
import { IoMail } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import dataEn from "../../../languages/en/footer";
import dataTh from "../../../languages/th/footer";

const Footer = ({ language }) => {
  const data = language === "en" ? dataEn : dataTh;

  const navigate = useNavigate();
  return (
    <footer className="mx-auto px-12 bg-gradient-to-b from-[#2925CC] to-[#4B48E5] text-white py-10">
      <div
        className="flex flex-col md:flex-row md:mt-4
        lg:flex-row lg:mt-4 lg:justify-start lg:items-start
      "
      >
        <div
          className="flex items-start justify-center  right-0 
          lg:w-52
        "
        >
          <img
            src={process.env.PUBLIC_URL + "/Logo/footer-logo.png"}
            alt="Logo"
            className="h-28 md:h-32 md:mr-20 md:mt-4
            lg:w-full
            "
          />
        </div>
        <div
          className="lg:flex lg:flex-row lg:justify-around lg:w-full lg:items-start lg:mt-4
          lg:gap-8 
        "
        >
          <div>
            <p
              className="my-4 text-left text-xs text-gray-300 leading-6
            lg:my-0  lg:text-lg"
            >
              {data.companyAddress1} <br />
              {data.companyAddress2} <br />
              {data.companyAddress3}
            </p>
            <div
              className="flex items-center mb-2 lg:mt-8
              lg:text-xl
            "
            >
              <AiFillPhone className="mr-2  rotate-90" />
              <span className=" text-gray-300 cursor-pointer">
                {data.phoneNumber}
              </span>
            </div>
            <div
              className="flex items-center
             lg:text-xl"
            >
              <IoMail className="mr-2" />
              <span className="text-gray-300">
                <a href={`mailto:${data.supportEmail}`}>{data.supportEmail}</a>
              </span>
            </div>
          </div>
          <div
            className="flex flex-col my-12 leading-6
          lg:my-0 lg:leading-8 lg:text-lg"
          >
            <h3
              className="font-thin mb-1
            
           lg:text-lg"
            >
              {data.privacy}
            </h3>
            <a
              className="mb-1  block  text-xs cursor-pointer
              text-gray-300 lg:my-4 lg:text-lg"
              onClick={() => {
                navigate("/termsAndConditions#terms");
              }}
            >
              {data.termsAndConditions}
            </a>
            <a
              className="mb-6 font-medium text-xs cursor-pointer
                   text-gray-300  lg:text-lg"
              onClick={() => {
                navigate("/policy/");
              }}
            >
              {data.privacyPolicy}
            </a>
            <h3 className="font-bold my-4">{data.followUs}</h3>
            <div
              className="flex items-center space-x-4 w-60
            lg:w-40 xl:w-60
            "
            >
              <a className="text-white" href={data.facebook}>
                <img
                  src={process.env.PUBLIC_URL + "/about us/footer/fb.png"}
                  alt="Facebook"
                />
              </a>
              <a className="text-white" href={data.line}>
                <img
                  src={process.env.PUBLIC_URL + "/about us/footer/line.png"}
                  alt="line"
                />
              </a>
              <a className="text-white" href={data.tiktok}>
                <img
                  src={process.env.PUBLIC_URL + "/about us/footer/tik-tok.png"}
                  alt="tiktok"
                />
              </a>
              <a className="text-white" href={data.youtube}>
                <img
                  src={process.env.PUBLIC_URL + "/about us/footer/youtube.png"}
                  alt="youtube"
                />
              </a>
            </div>
          </div>
          <div
            className="h-80 w-full mt-12 
          lg:w-72 lg:h-60 lg:mt-0

            "
          >
            <img
              src="https://i.ibb.co/syx1TYC/map.png"
              alt="Map"
              className="h-full w-full object-cover rounded-2xl"
            />
          </div>
        </div>
      </div>
      <div className="text-center mt-8 opacity-80 text-xs md:text-sm">
        <p>{data.copyRightText}</p>
      </div>
    </footer>
  );
};

export default Footer;
